import { throttle } from 'lodash';
import { useCallback, useEffect } from 'react';

interface UseInfiniteScrollOptions {
  distance?: number;
  enabled?: boolean;
}

export const useInfiniteScroll = (
  target: HTMLElement | null,
  callback: () => void,
  { distance = 10, enabled = true }: UseInfiniteScrollOptions = {},
) => {
  const handleInfiniteScroll = useCallback(() => {
    if (!target) return;

    const { scrollHeight, scrollTop, clientHeight } = target;
    const isAtBottom = scrollHeight - scrollTop - distance <= clientHeight;

    if (isAtBottom) {
      callback();
    }
  }, [target, callback, distance]);

  useEffect(() => {
    const throttleScroll = throttle(handleInfiniteScroll, 150);

    if (enabled) {
      target?.addEventListener('scroll', throttleScroll);
    }

    return () => {
      target?.removeEventListener('scroll', throttleScroll);
    };
  }, [target, handleInfiniteScroll, enabled]);

  return null;
};
